import React from 'react';
import { motion } from "framer-motion";
import img1 from "../Images/fast & reliable.svg";
import img2 from "../Images/easy booking.svg";
import img3 from "../Images/sefty.svg";
import img4 from "../Images/secure payment.svg";
import img5 from "../Images/tracking.svg";
import img6 from "../Images/support.svg";
import { useTranslation, Trans } from "react-i18next";

const cardVariant = {
  hidden: { opacity: 0, y: 60 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2,
      duration: 0.6
    }
  })
};

function Chooseus() {
  const { t, i18n } = useTranslation();

//  const chooseData = [
//   {
//     title: "Fast & Reliable",
//     desc: "Get quick and dependable rides whenever you need them, with drivers you can trust for a smooth and consistent experience every time."
//   },
//   {
//     title: "Easy Booking",
//     desc: "Book your ride effortlessly in just a few steps with our simple and user-friendly interface, designed to save you time and make travel stress-free."
//   },
//   {
//     title: "Safety First",
//     desc: "Your safety is our top priority, with verified drivers, real-time tracking, and secure systems ensuring every journey is protected and worry-free."
//   },
//   {
//     title: "Secure Payments",
//     desc: "Enjoy seamless and secure payment options with complete transparency, giving you a hassle-free experience from booking to payment completion."
//   },
//   {
//     title: "Real-Time Tracking",
//     desc: "Stay informed throughout your journey with live tracking, accurate updates, and complete visibility from pickup to your final destination."
//   },
//   {
//     title: "24/7 Support",
//     desc: "Our dedicated support team is available around the clock to assist you with any issues or questions, ensuring a smooth and reliable experience at all times."
//   }
// ];
  const chooseData = t("choose_cards", { returnObjects: true }); 
  
   const images = [img1, img2, img3, img4, img5, img6];

  const chooseDataWithImages = chooseData.map((item, index) => ({
    ...item,
    img: images[index]
  }));
return (
    <div className='chooseus-wrapping-sec pb-60' id="choose">
      <div className='container'>

        <div className='chooseuys-heading-wrap text-center d-flex flex-column align-items-center'>
          <h2 className='main-heading'> <Trans i18nKey="choose_title">
    Why Choose <span>TARARIDE</span>
  </Trans></h2>
          <div className='d-flex text-center align-items-center justify-content-center'>
            <p>{t("choose_desc")}</p>
          </div>
        </div>

        <div className='row'>
          {chooseDataWithImages.map((item, i) => (
            <motion.div
              className='col-md-6 col-lg-4 mb-4'
              key={i}
              variants={cardVariant}
              initial="hidden"
              whileInView="visible"
              custom={i}
              viewport={{ once: true }}
            >
              <div className='card choose-card h-100'>
                <div className='icon-box'>
                  <img className='card-logo' src={item.img} alt="icon" />
                </div>

                <h2>{item.title}</h2>
                <p>{item.desc}</p>

              </div>
            </motion.div>
          ))}
        </div>

      </div>
    </div>
  );
}

export default Chooseus;